import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  href?: string;
  children: React.ReactNode;
  className?: string;
}
export function Button({
  href,
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-6 py-4 md:px-8 md:py-4 text-sm md:text-base font-bold text-carbon bg-gold rounded-sm transition-all duration-300 w-full md:w-auto text-center tracking-wide';
  const content = <motion.div whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.98
  }} className="w-full md:w-auto" data-id="element-52">
      {href ? <a href={href} target="_blank" rel="noopener noreferrer" className={`${baseStyles} hover:shadow-[0_0_20px_rgba(242,183,5,0.3)] ${className}`} data-id="element-53">
          {children}
        </a> : <button className={`${baseStyles} hover:shadow-[0_0_20px_rgba(242,183,5,0.3)] ${className}`} {...props} data-id="element-54">
          {children}
        </button>}
    </motion.div>;
  return content;
}